// src/pages/admin/ImpersonationPage.jsx
import { useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { UserCog } from 'lucide-react'
import { adminImpersonationApi } from '../../api/services'
import { Card, CardBody, Button } from '../../components/common/ui'
import toast from 'react-hot-toast'

export default function ImpersonationPage() {
  const [userId, setUserId] = useState('')
  const impersonate = useMutation({
    mutationFn: () => adminImpersonationApi.start(userId),
    onSuccess: () => { toast.success('Impersonation started — opening new tab'); window.open('/', '_blank') },
    onError: e => toast.error(e.response?.data?.message || 'Failed to impersonate'),
  })

  return (
    <div className="max-w-md">
      <h1 className="text-xl font-display font-bold mb-6 flex items-center gap-2"><UserCog size={20} className="text-pink" /> User Impersonation</h1>
      <Card>
        <CardBody className="space-y-4">
          <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-3 text-xs text-yellow-800">
            ⚠️ Impersonating a user grants full access to their account. All actions will be logged.
          </div>
          <input className="input w-full" type="number" placeholder="User ID to impersonate" value={userId} onChange={e => setUserId(e.target.value)} />
          <Button loading={impersonate.isPending} disabled={!userId.trim()} onClick={() => impersonate.mutate()}>
            <UserCog size={16} /> Start Impersonation
          </Button>
        </CardBody>
      </Card>
    </div>
  )
}
